import './PolicyStyles.css';
import { exportToWord } from '../utils/exportToWord';

const TrainingAndDevelopmentPolicy = ({
  clientName,
  companyNumber,
  clientAddress,
  effectiveDate,
  trainingManagerContact,
  hrContact,
}) => {
  const handleExportToWord = () => {
    const policyContent = document.getElementById('policy-content');
    exportToWord(policyContent.innerHTML, "Training_and_Development_Policy.docx");
  };

  return (
    <div className="policy-container" id="policy-content">
      <h3 className="policy-title">Training and Development Policy</h3>

      <p className="policy-details"><strong>Company Name:</strong> {clientName || "[Insert Company Name]"}</p>
      <p className="policy-details"><strong>Company Number:</strong> {companyNumber || "[Insert Company Number]"}</p>
      <p className="policy-details"><strong>Company Address:</strong> {clientAddress || "[Insert Company Address]"}</p>
      <p className="policy-details"><strong>Policy Effective Date:</strong> {effectiveDate || "[Insert Effective Date]"}</p>

      <h4 className="section-title">1. Purpose</h4>
      <p className="section-content">
        {clientName || "The Company"} is committed to investing in the continuous training and professional development of all employees to enhance skills, performance, and career progression.
      </p>

      <h4 className="section-title">2. Scope</h4>
      <p className="section-content">
        This policy applies to all employees, contractors, and temporary workers engaged in any role within the company.
      </p>

      <h4 className="section-title">3. Training Needs Assessment</h4>
      <p className="section-content">
        Training needs will be identified through performance reviews, audits, regulatory requirements, and employee feedback.
      </p>

      <h4 className="section-title">4. Training and Development Planning</h4>
      <ul>
        <li>Development of annual training plans aligned with company objectives and compliance standards.</li>
        <li>Provision of mandatory and optional training courses relevant to roles.</li>
        <li>Support for external qualifications and continuous professional development (CPD).</li>
      </ul>

      <h4 className="section-title">Additional Training Provisions</h4>
      <p className="section-content">
        1. {clientName || "The Company"} will fund CPC refresher courses provided that the employee's CPC card remains valid for a minimum of six months following the commencement of their employment.[Delete as Required]<br />
        2. It is the sole responsibility of the employee to maintain the validity and currency of their CPC card. The company will not be responsible for funding refresher courses required due to card expiry or failure to meet renewal requirements.[Delete as Required]
      </p>
      <p className="section-content">
        By law, professional drivers are required to complete 35 hours of periodic training every five years. Each training module must be a minimum of seven hours in duration. Drivers may choose to complete this training either in one continuous period or spaced out over the five-year cycle, subject to the scheduling and availability provided by accredited training organisations.
      </p>

      <h4 className="section-title">5. Employee Responsibilities</h4>
      <ul>
        <li>Participate actively in assigned training sessions and apply learning to their roles.</li>
        <li>Identify personal development needs and communicate them to line managers.</li>
        <li>Maintain records of completed training and certifications.</li>
      </ul>

      <h4 className="section-title">6. Evaluation and Feedback</h4>
      <p className="section-content">
        Training effectiveness will be evaluated through assessments, feedback, and monitoring of performance improvements.
      </p>

      <h4 className="section-title">7. Continuous Improvement</h4>
      <p className="section-content">
        The company will regularly review training programmes to ensure they meet evolving business needs and regulatory requirements.
      </p>

      <h4 className="section-title">Contact Information</h4>
      <p><strong>Training Manager:</strong> {trainingManagerContact || "[Insert Contact]"}</p>
      <p><strong>Human Resources:</strong> {hrContact || "[Insert Contact]"}</p>

      <h4 className="section-title">Employee Acknowledgment and Signature</h4>
      <p>I confirm that I have read, understood, and agree to comply with the Training and Development Policy.</p>
      <p>Employee Name: _________________________</p>
      <p>Employee Signature: _________________________</p>
      <p>Date: _________________________</p>

      <h4 className="section-title">Management Approval and Signature</h4>
      <p>This policy has been approved by senior management and is now in effect.</p>
      <p>Manager/Officer Name: _________________________</p>
      <p>Title: _________________________</p>
      <p>Signature: _________________________</p>
      <p>Date: _________________________</p>

      <div className="mt-4 text-center">
        <button
          onClick={handleExportToWord}
          className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 transition"
        >
          Export to Word
        </button>
      </div>
    </div>
  );
};

export default TrainingAndDevelopmentPolicy;

